import { render } from "./shareDialog.vue?vue&type=template&id=055d3d08&scoped=true"
import script from "./shareDialog.vue?vue&type=script&lang=js"
export * from "./shareDialog.vue?vue&type=script&lang=js"

import "./shareDialog.vue?vue&type=style&index=0&id=055d3d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-055d3d08"]])

export default __exports__